<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="兑换记录名称">
          <el-input placeholder="请输入兑换记录名称/用户名/手机号" v-model="formInline.search" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加兑换记录</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="兑换记录名称"></el-table-column>
             <el-table-column prop="user.nickName" label="用户名称"></el-table-column>
             <el-table-column prop="user.mobile" label="用户手机号"></el-table-column>
            
            <!-- 新增状态列 -->
            <el-table-column prop="status" label="状态" width="100" align="center">
              <template slot-scope="scope">
                <el-tag 
                  :type="getStatusType(scope.row.is_receive)" 
                  size="small"
                >
                  {{ getStatusText(scope.row.is_receive) }}
                </el-tag>
              </template>
            </el-table-column>
            
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <!-- 已领取按钮 - 只有未领取状态显示 -->
                <el-button 
                  v-if="scope.row.is_receive === 0" 
                  @click="confirmReceive(scope.row)" 
                  type="text" 
                  size="small"
                  style="color: #67C23A;"
                >
                  已领取
                </el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small" style="color: #F56C6C;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :exchange_log_id="exchange_log_id" v-if="open_edit" @close="closeEdit"></Edit>

    <!-- 已领取确认对话框 -->
    <el-dialog
      title="确认领取"
      :visible.sync="receiveDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="text-align: center; padding: 20px 0;">
        <i class="el-icon-question" style="font-size: 48px; color: #E6A23C; margin-bottom: 15px;"></i>
        <p style="font-size: 16px; margin-bottom: 10px;">确定要将该兑换记录标记为已领取吗？</p>
        <p v-if="currentItem" style="color: #909399;">
          兑换记录：<strong>{{ currentItem.name }}</strong>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="receiveDialogVisible = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="handleReceive" 
          :loading="receiveLoading"
          style="background-color: #67C23A; border-color: #67C23A;"
        >
          确认领取
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Exchange_logApi from '@/api/exchange_log.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      supply_id: this.$route.query.supply_id,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_add: false,
      open_edit: false,
      exchange_log_id: "",
      dialogVisible: false,
      
      // 已领取相关数据
      receiveDialogVisible: false,
      receiveLoading: false,
      currentItem: null
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) { //兑换记录标题设置
      this.dialogVisible = true;
    },
    
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    
    getData() {
      this.getTableList();
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.supply_id = self.supply_id;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Exchange_logApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
          console.error("获取列表失败:", error);
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.exchange_log_id = row.exchange_log_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          Exchange_logApi.del(
            {
              exchange_log_id: row.exchange_log_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.getTableList();
              } else {
                self.$message.error('删除失败');
              }
            })
            .catch(error => {
              self.$message.error('删除失败');
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },

    /*确认领取*/
    confirmReceive(row) {
      this.currentItem = row;
      this.receiveDialogVisible = true;
    },

    /*处理领取*/
    handleReceive() {
      if (!this.currentItem) return;
      
      this.receiveLoading = true;
      
      // 调用已领取接口
      Exchange_logApi.receive(
        {
          exchange_log_id: this.currentItem.exchange_log_id
        },
        true
      )
        .then(data => {
          this.receiveLoading = false;
          if (data.code == 1) {
            this.$message({
              message: '标记为已领取成功',
              type: 'success'
            });
            this.receiveDialogVisible = false;
            this.getTableList(); // 刷新列表
          } else {
            this.$message.error(data.msg || '操作失败');
          }
        })
        .catch(error => {
          this.receiveLoading = false;
          this.$message.error('操作失败，请重试');
          console.error("标记领取失败:", error);
        });
    },

    /*获取状态文本*/
    getStatusText(status) {
      const statusMap = {
        0: '未领取',
        1: '已领取',
        2: '已过期'
      };
      return statusMap[status] || '未知';
    },

    /*获取状态标签类型*/
    getStatusType(status) {
      const typeMap = {
        0: 'warning',  // 未领取 - 黄色
        1: 'success',  // 已领取 - 绿色
        2: 'info'      // 已过期 - 灰色
      };
      return typeMap[status] || 'info';
    }
  }
};
</script>

<style>
/* 操作按钮样式优化 */
.el-button--text {
  padding: 5px 8px;
}

/* 表格行样式 */
.table-wrap .el-table .cell {
  padding: 8px 0;
}

/* 状态标签样式 */
.el-tag {
  font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/exchange/log/index.vue